module.exports = __webpack_public_path__ + "static/media/BT4.6a38b45d.pdf";